var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { EventEmitter } from "events";
import { AppJsApi } from "./../common/config";
import loadJs from "../common/loadjs";
import { createDeeplink } from "../common/scheme";
import { debugLogger, errorLogger } from '../../debug';
import { AppDownloadStatus } from "../../../common/constants";
/**
 * TBS下载器实现
 * 相关文档：http://tbs.wsd.com
 */
var TBSDownloader = /** @class */ (function (_super) {
    __extends(TBSDownloader, _super);
    function TBSDownloader(opt) {
        var _this = _super.call(this) || this;
        _this.name = 'TBSDownloader';
        _this.opt = __assign({}, opt);
        return _this;
    }
    TBSDownloader.prototype.ready = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadJs([AppJsApi.TBS])];
                    case 1:
                        _a.sent();
                        this.regAdStat();
                        return [2 /*return*/];
                }
            });
        });
    };
    TBSDownloader.prototype.start = function () {
        var _a, _b;
        var _c = this.opt, url = _c.url, reportstring = _c.reportstring, reportstring1 = _c.reportstring1, reportstring2 = _c.reportstring2, _d = _c.needautoinstall, needautoinstall = _d === void 0 ? true : _d, rest = __rest(_c, ["url", "reportstring", "reportstring1", "reportstring2", "needautoinstall"]);
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.startDownload) {
            var errorCode = window.tbs.download.startDownload(__assign({ url: url, needautoinstall: Boolean(needautoinstall) }, rest));
            if (errorCode < 0) {
                errorLogger('异常:', 'startDownload errorCode', errorCode);
                this.emit("apierror", errorCode);
                window.location.href = url;
            }
        }
        else {
            errorLogger('异常:', 'startDownload', '无此方法');
            this.tryOpen();
            window.location.href = url;
        }
    };
    /**
     * 补充内核统计上报
     *  type 上报的环节(0:下载开始;1:下载结束;2:安装完成)
     */
    TBSDownloader.prototype.regAdStat = function () {
        var _a, _b;
        var _c = this.opt, url = _c.url, reportstring = _c.reportstring, reportstring1 = _c.reportstring1, reportstring2 = _c.reportstring2;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.ad) === null || _b === void 0 ? void 0 : _b.reportMsgByURL) {
            window.tbs.ad.reportMsgByURL({
                appUrl: url,
                type: "0",
                reportUrl: reportstring,
            });
            window.tbs.ad.reportMsgByURL({
                appUrl: url,
                type: "1",
                reportUrl: reportstring1,
            });
            window.tbs.ad.reportMsgByURL({
                appUrl: url,
                type: "2",
                reportUrl: reportstring2,
            });
        }
        else {
            errorLogger('异常:', 'reportMsgByURL', '无此方法');
        }
    };
    TBSDownloader.prototype.pause = function () {
        var _a, _b;
        var url = this.opt.url;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.pauseDownload) {
            window.tbs.download.pauseDownload({ url: url });
        }
        else {
            errorLogger('异常:', 'pauseDownload', '无此方法');
        }
    };
    TBSDownloader.prototype.resume = function () {
        var _a, _b;
        var url = this.opt.url;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.resumeDownload) {
            window.tbs.download.resumeDownload({ url: url });
        }
        else {
            errorLogger('异常:', 'resumeDownload', '无此方法');
            this.start();
        }
    };
    TBSDownloader.prototype.install = function () {
        var _this = this;
        var _a, _b;
        var url = this.opt.url;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.installApp) {
            var errorCode = window.tbs.download.installApp({ url: url }, function (res) {
                if (res === void 0) { res = {}; }
                _this.emit("install", /install:/gi.test(res.ret || ""));
            });
            if (errorCode < 0) {
                errorLogger('异常:', 'installApp errorCode', 'errorCode');
                this.emit("install_error", errorCode);
                this.start();
            }
        }
        else {
            this.emit("install_error");
            errorLogger('异常:', 'installApp', '无此方法');
            this.start();
        }
    };
    TBSDownloader.prototype.open = function () {
        var _a, _b;
        var _c = this.opt, packagename = _c.packagename, active = _c.active, posId = _c.posId;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.package) === null || _b === void 0 ? void 0 : _b.runApp) {
            window.tbs.package.runApp({
                packagename: packagename,
                url: active, PosID: posId,
            }, function (rst) {
                debugLogger('调起APP', 'runApp', rst);
            });
        }
        else {
            errorLogger('异常:', 'runApp', '无此方法');
        }
        if (active) {
            location.href = active;
        }
        else {
            location.href = createDeeplink(packagename);
        }
    };
    TBSDownloader.prototype.tryOpen = function (cb) {
        var _this = this;
        var active = this.opt.active;
        if (active && this.count < 1) {
            this.count++;
            var ifr_1 = document.createElement("iframe");
            ifr_1.src = active;
            ifr_1.style.display = "none";
            document.body.appendChild(ifr_1);
            setTimeout(function () {
                document.body.removeChild(ifr_1);
                _this.emit('open_error');
                _this.status = false;
                cb && cb();
            }, 500);
        }
    };
    TBSDownloader.prototype.isInstalled = function () {
        var packagename = this.opt.packagename;
        return new Promise(function (resolve, reject) {
            var _a, _b;
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.package) === null || _b === void 0 ? void 0 : _b.isApkInstalled) {
                var isInstalled = window.tbs.package.isApkInstalled({ packagename: packagename });
                resolve(Number(isInstalled) === 1);
            }
            else {
                resolve(false);
                errorLogger('异常:', 'isApkInstalled', '无此方法');
            }
        });
    };
    TBSDownloader.prototype.getStatus = function () {
        var _a, _b;
        var url = this.opt.url;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.getDownloadStatus) {
            return window.tbs.download.getDownloadStatus({ url: url });
        }
        errorLogger('异常:', 'getDownloadStatus', '无此方法');
        return AppDownloadStatus.TASK_STATUS_NONE;
    };
    TBSDownloader.prototype.getProgress = function () {
        var url = this.opt.url;
        return new Promise(function (resolve, reject) {
            var _a, _b, _c, _d;
            if (((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.getDownloadFileTotalSize) &&
                ((_d = (_c = window === null || window === void 0 ? void 0 : window.tbs) === null || _c === void 0 ? void 0 : _c.download) === null || _d === void 0 ? void 0 : _d.getDownloadProgress)) {
                var progress = 0;
                var totalSize = window.tbs.download.getDownloadFileTotalSize({ url: url });
                if (!Number.isNaN(totalSize) && Number(totalSize) !== 0) {
                    progress = Math.floor((window.tbs.download.getDownloadProgress({ url: url }) / totalSize) * 100);
                }
                resolve(progress);
            }
            else {
                resolve(0);
                errorLogger('异常:', 'getDownloadFileTotalSize/getDownloadProgress', '无此方法');
            }
        });
    };
    return TBSDownloader;
}(EventEmitter));
export default TBSDownloader;
